import OfferSummary from "./OfferSummary";

export default OfferSummary;
